import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  embedContainer: {
    height: '800px',
    width: '1600px',
    padding: '40px'
  },
  iFrameWrapper: {
    padding: '25px'
  },
  powerBiReport: {
    minHeight: '90vh',
    width: '100%',
    height: '100%',
    padding: '20px',
    border: '1px solid'

  }
}));

//const iFrameEmbedUrl = "https://app.powerbi.com/reportEmbed?reportId=d38e2960-f3b1-4b5e-965a-886d669bb15c&autoAuth=true&ctid=aff3442b-5f55-409c-be77-da97b366435a";
const iFrameEmbedUrl = process.env.REACT_APP_POWERBI

export default function EmbeddedReport() {
  const classes = useStyles();

  return (    
    <>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justify="center"
        className={classes.iFrameWrapper}>
          <iframe id="power-bi-report"
                className={classes.powerBiReport}
                src={iFrameEmbedUrl}
                frameborder={0}
                allowFullScreen={true}
                title="Dashboard">
          </iframe>
      </Grid> 
    </>
  );
}